namespace GeniuzPOS.Supplier {
    export class CsSupplierColumns {
        static columnsKey = 'Supplier.CsSupplier';
    }
}
